export default "__VITE_ASSET__DfoAppbp__"